import React from "react";
import { nanoid } from "nanoid";
import useIsMobile from "../../hooks/useIsMobile";

/*
 *
 * Created on Thu 14 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

const Tab = ({ tabs, activeTab, setActiveTab }) => {
  const isMobile = useIsMobile({ breakpoint: 992 });

  const handleTabClick = tabIndex => {
    setActiveTab(tabIndex);
  };

  return (
    <div
      className="tab"
      style={{
        textAlign: "left",
        display: isMobile ? "flex" : "unset",
        justifyContent: isMobile ? "center" : "unset",
        gap: isMobile ? "24px" : "unset",
      }}
    >
      <div
        className="tab__header"
        style={{
          display: "flex",
          justifyContent: isMobile ? "space-evenly" : "center",
          backgroundColor: "#00AEF0",
          width: "fit-content",
          margin: isMobile ? "unset" : "auto",
          borderRadius: "80px",
          padding: isMobile ? "16px 8px" : 8,
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {tabs.map((tab, index) => (
          <button
            className={`tab__button ${activeTab === index ? "active" : ""}`}
            onClick={() => handleTabClick(index)}
            style={{
              all: "unset",
              fontSize: "0.875rem",
              lineHeight: "100%",
              fontMedium: 500,
              color: activeTab === index ? "#00AEF0" : "#ffffff",
              textAlign: "center",
              padding: "6px 8px",
              backgroundColor: activeTab === index ? "#ffffff" : "transparent",
              borderRadius: "80px",
              cursor: "pointer",
            }}
            key={nanoid()}
          >
            {tab.title}
          </button>
        ))}
      </div>
      <div
        className="tab__content"
        style={{ width: "fit-content", margin: isMobile ? "unset" : "auto" }}
      >
        {tabs[activeTab].content}
      </div>
    </div>
  );
};

export default Tab;
